import React from "react";

export const FormContext = React.createContext({
	getValue: () => null,
	validate: () => null,
	onChange: () => null,
	onSubmit: () => null,
	showErrors: false,
	submitOnEnter: true
});

export const RouteContext = React.createContext({
	route: "/"
});

export const ModalContext = React.createContext({
	modalType: "",
	show: false,
	toggleModal: () => {}
});


// WEBPACK FOOTER //
// ./src/contexts.js